import { Component, OnInit, Input } from '@angular/core';
import { httpService } from '../service/servicio';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private http:httpService, public toastr: ToastsManager, vcr: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vcr);

  }

  ngOnInit() {
  }

  user:string = '';
  pass:string = '';

  @Input() usuario:any = {

     Id: 0,
     User: '',
     Pass: '',
     Otro: 0

  };

  logged:string;

  login() {

     ("en login");
    this.http.hacer_login(this.user, this.pass)
    .subscribe(usuario => {
       (usuario);
      this.usuario = usuario;
    }, err => {
      this.usuario.Id = 0;
       (err.message);
    }, () => {

       ('completed');

      if (this.usuario.Id > 0) {

          this.toastr.success('Login Correcto. Bienvenido: ' + this.usuario.User,'Login');

          this.http.user = this.usuario.User;
          this.http.pass = this.usuario.Pass;

          localStorage.setItem("logged", "1");
          localStorage.setItem("usuario", JSON.stringify(this.usuario));

          if (this.usuario.Otro == 0) {
            this.http.sw.mostrarLogin = false;
            this.http.sw.mostrarMenu = true;
            this.http.sw.mostrarMaquinas = true;
            this.http.modoOperador = false;
          } else {
            this.http.sw.mostrarLogin = false;
            this.http.sw.mostrarMenu = false;
            this.http.sw.mostrarCargasOperador = true;
            this.http.modoOperador = true;
          }
              

      }else {

          this.toastr.error("Compruebe los Datos",'Login Incorrecto');
      }

    });
  }

  procesalogin() {

    if (this.usuario.Id > 0) {

        localStorage.setItem("logged", "1");
        localStorage.setItem("usuario", JSON.stringify(this.usuario));
        this.toastr.success('Login Correcto. Bienvenido: ' + this.usuario.User,'Login');
        if (this.usuario.Otro == 0) {
          this.http.sw.mostrarLogin = false;
          this.http.sw.mostrarMenu = true;
          this.http.sw.mostrarMaquinas = true;
          this.http.modoOperador = false;
        } else {
          this.http.sw.mostrarLogin = false;
          this.http.sw.mostrarMenu = false;
          this.http.sw.mostrarCargas = true;
          this.http.modoOperador = true;
        }
        

    }else {

        this.toastr.error("Compruebe los Datos",'Login Incorrecto');
    }
  }



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/login/login.component.ts